module.exports = __webpack_public_path__ + "static/img/weChatRedPacketBackground.8dab33ed.png";